import { render, staticRenderFns } from "./InfoBudget.vue?vue&type=template&id=43026bc5&"
import script from "./InfoBudget.vue?vue&type=script&lang=js&"
export * from "./InfoBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports